const faq_en = require('./faq.json')
export default faq_en